'use es6';

import { Map as ImmutableMap } from 'immutable';
import ActionTypes from 'LearningCenterUI/actions/ActionTypes';
const INITIAL_STATE = ImmutableMap({
  data: null,
  hasError: false,
  recentError: null,
  isRequesting: false,
  topicPreferences: ImmutableMap({
    data: null,
    hasError: false,
    recentError: null,
    isRequesting: false
  })
});
export default function Recommendations(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ActionTypes.RECOMMENDATIONS_REQUESTING:
      return state.merge({
        isRequesting: true,
        hasError: false
      });

    case ActionTypes.RECOMMENDATIONS_RECEIVED:
      return state.merge({
        isRequesting: false,
        hasError: false,
        data: action.payload.get('recommendations')
      });

    case ActionTypes.RECOMMENDATIONS_ERROR:
      return state.merge({
        isRequesting: false,
        hasError: true,
        recentError: action.payload
      });

    case ActionTypes.TOPIC_PREFERENCES_REQUESTING:
      return state.mergeIn(['topicPreferences'], {
        isRequesting: true,
        hasError: false
      });

    case ActionTypes.TOPIC_PREFERENCES_RECEIVED:
      return state.mergeIn(['topicPreferences'], {
        isRequesting: false,
        hasError: false,
        data: action.payload
      });

    case ActionTypes.TOPIC_PREFERENCES_ERROR:
      return state.mergeIn(['topicPreferences'], {
        isRequesting: false,
        hasError: true,
        recentError: action.payload
      });

    case ActionTypes.SET_TOPIC_PREFERENCES_SUCCESS:
      return state.mergeIn(['topicPreferences'], {
        data: action.payload
      });

    default:
      return state;
  }
}